import React from "react";
import { Entity } from "@common/types/entity";
import { Button } from "@design-system/Button/Button";
import { useCommands } from "../commands/useCommands";

import { CommandsDirectory } from "../commands/lib";

interface Props {
    btnText: string;
    btnVariant: "primary" | "secondary";
    btnSize?: "sm" | "md" | "lg" | "xl";
    btnClassName?: string;
    defaultEntity?: Entity;
}

export const AddAccount: React.FC<Props> = ({
    btnClassName,
    btnSize,
    btnText,
    btnVariant,
    defaultEntity,
}) => {
    const { open } = useCommands();

    return (
        <Button
            onClick={() => open(CommandsDirectory.ACCOUNTS, { defaultEntity })}
            variant={btnVariant}
            className={btnClassName}
            size={btnSize ?? "md"}
            data-testid="add-account-btn"
        >
            {btnText}
        </Button>
    );
};
